// extracted by mini-css-extract-plugin
module.exports = {"module":"CountBubble_module__2HTHr"};